import Author from "../components/Sidebar";
import PostShow from "../components/PostShow";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import "./Home.css";

function Home() {

  return (
   

    <Container className="">
      <Row className="gx-5">
        <Col sm={8}>  <PostShow/> </Col>
        <Col className="sidebar-style" sm={4}>  <Author/></Col>
      </Row>
    </Container>

  );
}

export default Home;
